<div class="container" *ngIf="!!context && !error">
  <div class="mb-4">
    <h2 class="text-center">
      <span translate>THANK_YOU_HEADER</span>
    </h2>
    <p class="text-center">
      <span translate>ORDER_ID</span>:
      {{ context.erpOrderIds[0] }}
    </p>
    <div
      *ngIf="
        context.originalInput &&
          context.originalInput.confirmationEmails &&
          context.originalInput.confirmationEmails.length > 0;
        else loading
      "
    >
      <p class="text-center">
        {{ 'THANK_YOU_EMAIL_CONFIRMATION_FROM_CONTEXT_ORIGINAL_INPUT' | translate }}:
        {{ context.originalInput.confirmationEmails.join(', ') }}
      </p>
    </div>
    <ng-template #loading translate>
      <p class="text-center" translate>THANK_YOU_EMAIL_CONFIRMATION</p>
    </ng-template>
  </div>
</div>
<div class="container" *ngIf="error">
  <div class="mb-4">
    <p class="text-center">ERROR_OCCURED</p>
  </div>
</div>
